__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/1ab943dc5edf49dc483bd47f61248346a676d697e02f0a66aa7d7457/";